"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgDatabaseFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("defs", null,
            React.createElement("style", null, '.database_filled_svg__cls-1{display:none}')),
        React.createElement("g", { id: "database_filled_svg__transparent_box" },
            React.createElement("path", { className: "database_filled_svg__cls-1", d: "M0 0h32v32H0z" }),
            React.createElement("path", { className: "database_filled_svg__cls-1", d: "M0 0h32v32H0z" })),
        React.createElement("g", { id: "database_filled_svg__FILLED" },
            React.createElement("path", { d: "M6 23.08V25c0 2.85 4.3 5 10 5s10-2.15 10-5v-1.92C23.92 24.9 20.37 26 16 26s-7.92-1.1-10-2.92z" }),
            React.createElement("path", { d: "M6 17.08V19c0 2.85 4.3 5 10 5s10-2.15 10-5v-1.92C23.92 18.9 20.37 20 16 20s-7.92-1.1-10-2.92z" }),
            React.createElement("path", { d: "M6 11.08V13c0 2.85 4.3 5 10 5s10-2.15 10-5v-1.92C23.92 12.9 20.37 14 16 14s-7.92-1.1-10-2.92z" }),
            React.createElement("ellipse", { cx: 16, cy: 7, rx: 10, ry: 5 }))));
}
exports.default = SvgDatabaseFilled;
//# sourceMappingURL=DatabaseFilled.js.map